import type { ModuleGroup } from './modules.tsx'

/**
 * Os grupos do menu, na ordem do menu lateral — a Equipe (F038) e o console da
 * plataforma (F172) agrupam as telas do mesmo jeito que a pessoa as encontra.
 */
export const GROUP_ORDER: readonly ModuleGroup[] = [
  'operação',
  'atendimento',
  'catálogo',
  'gestão',
  'administração',
]

export const GROUP_LABELS: Record<ModuleGroup, string> = {
  operação: 'Operação',
  atendimento: 'Atendimento',
  catálogo: 'Catálogo',
  gestão: 'Gestão',
  administração: 'Administração',
}
